import {
  IconSettings,
  IconCoin,
  IconBusinessplan,
  IconPrinter,
  IconFileInvoice,
  IconFriends
} from '@tabler/icons';
import { Icon } from '@iconify/react';
import peopleFill from '@iconify/icons-eva/people-fill';

const icons = {
  IconSettings,
  IconCoin,
  IconBusinessplan,
  IconPrinter,
  IconFileInvoice,
  IconFriends
};

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

const customermgmt = {
  id: 'pages',
  title: 'Loans & Customer',
  type: 'group',
  children: [
    {
      id: 'customer',
      title: 'Members',
      type: 'item',
      url: '/dashboard/client',
      icon: getIcon(peopleFill),
      breadcrumbs: false
    },
    {
      id: 'membMgmt',
      title: 'Member Management',
      type: 'collapse',
      icon: icons.IconFriends,
      children: [
        {
          id: 'extraRec',
          title: 'Process Receipts',
          type: 'item',
          url: '/accounts/extrareceipt',
          target: false
        },
        {
          id: 'extraSumRec',
          title: 'Receipt Summary',
          type: 'item',
          url: '/reportsnew/receiptlist',
          target: false
        },
        {
          id: 'ssbproc',
          title: 'Submit SSB',
          type: 'item',
          url: '/accounts/selectssb',
          target: false
        },
        {
          id: 'memberBala',
          title: 'File Reports',
          type: 'item',
          url: '/accounts/memberbalances',
          target: false
        },
        {
          id: 'webapp',
          title: 'Web Applications',
          type: 'item',
          url: '/clientportfolio/webapplications',
          target: false
        },
        {
          id: 'membSummary',
          title: 'Members by Group',
          type: 'item',
          url: '/reportsnew/membersbygroup',
          target: false
        },
        {
          id: 'membSummaryDt',
          title: 'Members by Group Detail',
          type: 'item',
          url: '/reportsnew/membersbygroupdetail',
          target: false
        },
        {
          id: 'membership',
          title: 'Full Membership',
          type: 'item',
          url: '/reports/fullmembership',
          breadcrumbs: false
        },
        {
          id: 'memberchanges',
          title: 'Membership Changes',
          type: 'item',
          url: '/reports/membershipchanges',
          breadcrumbs: false
        },
        {
          id: 'membershipstats',
          title: 'Membership Stats',
          type: 'item',
          url: '/reports/membershipstats',
          breadcrumbs: false
        },
        {
          id: 'membershipagestats',
          title: 'Membership Age Stats',
          type: 'item',
          url: '/reports/membershipagestats',
          breadcrumbs: false
        },
        {
          id: 'selfregister',
          title: 'Self Register',
          type: 'item',
          url: '/selfregister',
          breadcrumbs: false
        },
        {
          id: 'onoff',
          title: 'On/OFF Dashboard',
          type: 'item',
          url: '/ssb/onoffdash',
          breadcrumbs: false
        },
        {
          id: 'mgmt',
          title: 'Mgmt Dashboard',
          type: 'item',
          url: '/managementdash',
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'subs',
      title: 'Subscriptions',
      type: 'collapse',
      icon: icons.IconBusinessplan,
      children: [
        // {
        //   id: 'extractFil',
        //   title: 'Receipts - Current File',
        //   type: 'item',
        //   url: '/accounts/extractssb',
        //   target: false
        // },
        // {
        //   id: 'historyFile',
        //   title: 'Receipts - Old File',
        //   type: 'item',
        //   url: '/ssb/bulkbilldetails',
        //   target: false
        // },
        {
          id: 'processRec',
          title: 'SSB Process Files',
          type: 'item',
          url: '/accounts/receiptfile',
          target: false
        },
        {
          id: 'changefile',
          title: 'SSB Change Files',
          type: 'item',
          url: '/ssb/changefile',
          target: false
        },
        {
          id: 'processBills',
          title: 'Monthly Bill Subs',
          type: 'item',
          url: '/accounts/selectbill',
          target: false
        },
        {
          id: 'fileLooksup',
          title: 'File Lookup View',
          type: 'item',
          url: '/ssb/filesinfo',
          target: false
        },
        {
          id: 'extraRec',
          title: 'Individual Receipts',
          type: 'item',
          url: '/accounts/extrareceipt',
          target: false
        }
      ]
    },
    {
      id: 'claims',
      title: 'Claims Management',
      type: 'collapse',
      icon: icons.IconCoin,
      children: [
        {
          id: 'processClaims',
          title: 'Process Claims',
          type: 'item',
          url: '/claims/selectBatch',
          target: false
        },
        {
          id: 'memberLookup',
          title: 'Member Look Up',
          type: 'item',
          url: '/dashboard/client',
          target: false
        },
        {
          id: 'benefitsLookup',
          title: 'Benefits Look Up',
          type: 'item',
          url: '/claims/benefitsLookup',
          target: false
        },
        {
          id: 'claimsSearch',
          title: 'Search Claims',
          type: 'item',
          url: '/claims/claimsSearch',
          target: false
        },
        {
          id: 'tariffsSearch',
          title: 'Search Products',
          type: 'item',
          url: '/settings/tariffsSearch',
          target: false
        }
        // {
        //   id: 'providers',
        //   title: 'Provider Lookup',
        //   type: 'item',
        //   url: '/dashboard/providers',
        //   target: false
        // },
        // {
        //   id: 'remittance',
        //   title: 'Print Remittance',
        //   type: 'item',
        //   url: '/reports/remittance',
        //   breadcrumbs: false
        // },
        // {
        //   id: 'remittanceSelf',
        //   title: 'Remittance - Self',
        //   type: 'item',
        //   url: '/reports/remittanceself',
        //   target: false
        // }
      ]
    },
    {
      id: 'receiptAccounts',
      title: 'Receipting',
      type: 'collapse',
      icon: icons.IconBusinessplan,
      children: [
        {
          id: 'extractFil',
          title: 'Extract File',
          type: 'item',
          url: '/accounts/extractssb',
          target: false
        },
        {
          id: 'processRec',
          title: 'Process Receipt',
          type: 'item',
          url: '/accounts/receiptfile',
          target: false
        },
        {
          id: 'processBills',
          title: 'Monthly Bill Subs',
          type: 'item',
          url: '/accounts/selectbill',
          target: false
        }
      ]
    },
    {
      id: 'accounting',
      title: 'Accounting',
      type: 'collapse',
      icon: icons.IconFileInvoice,
      children: [
        {
          id: 'provideraccount',
          title: 'Provider Accounts',
          type: 'item',
          url: '/accounts/provideraccount',
          target: false
        },
        {
          id: 'updateJournals',
          title: 'Process Journals',
          type: 'item',
          url: '/accounts/vouchers',
          target: false
        },
        {
          id: 'updateSelfJournals',
          title: 'Process Self Journals',
          type: 'item',
          url: '/accounts/selfvouchers',
          target: false
        },
        {
          id: 'provBala',
          title: 'Provider Balances',
          type: 'item',
          url: '/accounts/providerbalances',
          target: false
        },
        {
          id: 'selfBala',
          title: 'Self Pmts Balances',
          type: 'item',
          url: '/accounts/selfpmtsbalances',
          target: false
        },
        {
          id: 'extraPmts',
          title: 'Pay Providers Adhoc',
          type: 'item',
          url: '/accounts/extrapayment',
          target: false
        }
        // {
        //   id: 'cbSelfPmts',
        //   title: 'Cash Book - Self Pmts',
        //   type: 'item',
        //   url: '/underdev',
        //   target: false
        // }
      ]
    },
    {
      id: 'reportsmember',
      title: 'Reports - Members',
      type: 'collapse',
      icon: icons.IconPrinter,
      children: [
        {
          id: 'memberprovince',
          title: 'Members By Province',
          type: 'item',
          url: '/membershipreports/byprovince',
          breadcrumbs: false
        },
        {
          id: 'memberage',
          title: 'Members By Age',
          type: 'item',
          url: '/membershipreports/byage',
          breadcrumbs: false
        },
        {
          id: 'retire',
          title: 'By Retirement',
          type: 'item',
          url: '/membershipreports/byretire',
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'reports',
      title: 'Reports',
      type: 'collapse',
      icon: icons.IconPrinter,
      children: [
        {
          id: 'extraSumRec',
          title: 'Receipt Summary',
          type: 'item',
          url: '/reportsnew/receiptlist',
          target: false
        },
        {
          id: 'defaults',
          title: 'Unpaid Subs',
          type: 'item',
          url: '/ssb/defaults',
          target: false
        },
        {
          id: 'memberSummary',
          title: 'Member Summary',
          type: 'item',
          url: '/membershipreports/bysummary',
          target: false
        },
        {
          id: 'memberBala',
          title: 'File Reports',
          type: 'item',
          url: '/reports/fileReport',
          target: false
        },
        {
          id: 'memberprovince',
          title: 'Members By Province',
          type: 'item',
          url: '/membershipreports/byprovince',
          breadcrumbs: false
        },
        {
          id: 'memberdistrict',
          title: 'Members By District',
          type: 'item',
          url: '/membershipreports/bydistrict',
          breadcrumbs: false
        },
        {
          id: 'memberbreak',
          title: 'Members By District (2)',
          type: 'item',
          url: '/membershipreports/bybreakdown',
          breadcrumbs: false
        },

        {
          id: 'memberage',
          title: 'Members By Age',
          type: 'item',
          url: '/membershipreports/byage',
          breadcrumbs: false
        },
        {
          id: 'retire',
          title: 'By Retirement',
          type: 'item',
          url: '/membershipreports/byretire',
          breadcrumbs: false
        },
        {
          id: 'provincefiles',
          title: 'Monthly Files',
          type: 'item',
          url: '/membershipreports/byprovincefile',
          breadcrumbs: false
        },
        {
          id: 'membership',
          title: 'Full Membership',
          type: 'item',
          url: '/reports/fullmembership',
          breadcrumbs: false
        },
        {
          id: 'memberchanges',
          title: 'Membership Changes',
          type: 'item',
          url: '/reports/membershipchanges',
          breadcrumbs: false
        },
        {
          id: 'membershipstats',
          title: 'Membership Stats',
          type: 'item',
          url: '/reports/membershipstats',
          breadcrumbs: false
        },
        {
          id: 'membershipagestats',
          title: 'Membership Age Stats',
          type: 'item',
          url: '/reports/membershipagestats',
          breadcrumbs: false
        }
      ]
    }
  ]
};

export default customermgmt;
